import { useEffect, useState } from "react";

export default function AnimatedWords() {
  const words = ["VoIP", "CRM", "API"];
  const [currentWordIndex, setCurrentWordIndex] = useState(0);
  const [displayed, setDisplayed] = useState("");
  const [isDeleting, setIsDeleting] = useState(false);

  useEffect(() => {
    const word = words[currentWordIndex];

    const timeout = setTimeout(
      () => {
        if (!isDeleting) {
          const next = word.substring(0, displayed.length + 1);
          setDisplayed(next);

          if (next === word) {
            setTimeout(() => setIsDeleting(true), 1000);
          }
        } else {
          const next = displayed.substring(0, displayed.length - 1);
          setDisplayed(next);
          if (next === "") {
            setIsDeleting(false);
            setCurrentWordIndex((prev) => (prev + 1) % words.length);
          }
        }
      },
      isDeleting ? 200 : 240
    );
    return () => clearTimeout(timeout);
  }, [displayed, isDeleting, currentWordIndex]);

  return <span className="animated-word">{displayed} ?</span>;
}
